module.exports = __webpack_public_path__ + "img/newMap.53ad164a.jpg";